import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MenuAsideDirective} from './directives/menu-aside.directive';
import {MenuAsideOffcanvasDirective} from './directives/menu-aside-offcanvas.directive';
import {MenuHorizontalOffcanvasDirective} from './directives/menu-horizontal-offcanvas.directive';
import {MenuHorizontalDirective} from './directives/menu-horizontal.directive';
import {ClipboardDirective} from './directives/clipboard.directive';
import {ScrollTopDirective} from './directives/scroll-top.directive';
import {HeaderDirective} from './directives/header.directive';
import {MenuAsideToggleDirective} from './directives/menu-aside-toggle.directive';
import {QuickSidebarOffcanvasDirective} from './directives/quick-sidebar-offcanvas.directive';
import {FirstLetterPipe} from './pipes/first-letter.pipe';
import {TimeElapsedPipe} from './pipes/time-elapsed.pipe';
import {QuickSearchDirective} from './directives/quick-search.directive';
import {JoinPipe} from './pipes/join.pipe';
import {GetObjectPipe} from './pipes/get-object.pipe';
import {ConsoleLogPipe} from './pipes/console-log.pipe';
import {SafePipe} from './pipes/safe.pipe';
import {ReplaceStringPipe} from './pipes/replace-string.pipe';
import {GooglePlacesDirective} from './directives/google-places.directive';
import {PhoneMaskDirective} from './directives/phone-mask.directive';
import {SSNMaskDirective} from './directives/ssn-mask.directive';
import {DateMaskDirective} from './directives/date-mask.directive';
import {DOBValidatorDirective} from './directives/dob-validator.directive';
import {AlphabetDirective} from './directives/alphabet-only.directive';
import {ValidateDateDirective} from '@core/validator/date-validator.directive';
import {CurrencyPipe} from '@core/pipes/currency.pipe';
import {DateFormateDirective} from '@core/directives/dateformat-only.directive';
import {SubmitIfValidDirective} from '@core/directives/submit.directive';
import {DatePickerModule} from '@core/adapter/DatePickerModule';
import {CustomMinMaxValidatorDirective} from '@core/validator/min-max-validator.directive';
import {SalaryValidatorDirective} from '@core/validator/salary-validator.directive';
import {CurrenyFormatDirective} from '@core/directives/curreny-format.directive';
import {NumberDirective} from '@core/directives/numbers-only.directive';
import {VinCheckValidatorDirective} from '@core/validator/vin-check-validator.directive';
import {InputNumberDirective} from '@core/directives/input-number.directive';
import {StepperAriaFixDirective} from '@core/directives/stepper-aria-fix.directive';
import {ApplicationCodesDescription} from '@core/pipes/app-codes-desc.pipe';
import {CountyByzipcodeDirective} from '@core/directives/county-byzipcode.directive';
import {UppercaseDirective} from '@core/directives/uppercase.directive';
import {AlphabetWithSpaceDirective} from '@core/directives/alphabet-with-space.directive';
import {PoboxAllowedDirective} from '@core/directives/pobox-allowed.directive';
import { NumbersAndSlashDirective } from '@core/directives/numbers-and-slash.directive';
import {TrimDirective} from '@core/directives/trim.directive';
import {MatFormFieldModule} from '@angular/material/form-field';
import {ZipcodeDirective} from '@core/directives/zipcode.directive';
import {ReplaceUnderscorePipe} from '@core/pipes/replace-underscore.pipe';
import { SnackbarComponent } from './_shared/snackbar/snackbar.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatButtonModule} from '@angular/material/button';
import {SearchCountryPipe} from '@core/pipes/search-country.pipe';

@NgModule({
    imports: [CommonModule, MatFormFieldModule, DatePickerModule, MatSnackBarModule, MatButtonModule],
    declarations: [
        // directives
        MenuAsideDirective,
        MenuAsideOffcanvasDirective,
        MenuHorizontalOffcanvasDirective,
        MenuHorizontalDirective,
        ScrollTopDirective,
        HeaderDirective,
        MenuAsideToggleDirective,
        QuickSidebarOffcanvasDirective,
        QuickSearchDirective,
        ClipboardDirective,
        GooglePlacesDirective,
        NumberDirective,
        PhoneMaskDirective,
        SSNMaskDirective,
        DateMaskDirective,
        DOBValidatorDirective,
        AlphabetDirective,
        ValidateDateDirective,
        SubmitIfValidDirective,
        InputNumberDirective,
        CurrenyFormatDirective,
        DateFormateDirective,
        CustomMinMaxValidatorDirective,
        SalaryValidatorDirective,
        VinCheckValidatorDirective,
        CountyByzipcodeDirective,
        ValidateDateDirective,
        UppercaseDirective,
        ZipcodeDirective,
        PoboxAllowedDirective,
        TrimDirective,
        StepperAriaFixDirective,
        // pipes
        FirstLetterPipe,
        TimeElapsedPipe,
        JoinPipe,
        GetObjectPipe,
        ConsoleLogPipe,
        SafePipe,
        CurrencyPipe,
        ReplaceStringPipe,
        ReplaceUnderscorePipe,
        SearchCountryPipe,
        ApplicationCodesDescription,
        AlphabetWithSpaceDirective,
        SnackbarComponent,
        NumbersAndSlashDirective,
    ],
    exports: [
        // directives
        MenuAsideDirective,
        MenuAsideOffcanvasDirective,
        MenuHorizontalOffcanvasDirective,
        MenuHorizontalDirective,
        ScrollTopDirective,
        HeaderDirective,
        MenuAsideToggleDirective,
        QuickSidebarOffcanvasDirective,
        QuickSearchDirective,
        ClipboardDirective,
        GooglePlacesDirective,
        CurrenyFormatDirective,
        NumberDirective,
        PhoneMaskDirective,
        SSNMaskDirective,
        DateMaskDirective,
        DOBValidatorDirective,
        AlphabetDirective,
        ValidateDateDirective,
        SubmitIfValidDirective,
        InputNumberDirective,
        CustomMinMaxValidatorDirective,
        CountyByzipcodeDirective,
        SalaryValidatorDirective,
        VinCheckValidatorDirective,
        ValidateDateDirective,
        UppercaseDirective,
        PoboxAllowedDirective,
        TrimDirective,
        ZipcodeDirective,
        StepperAriaFixDirective,
        // pipes
        FirstLetterPipe,
        TimeElapsedPipe,
        JoinPipe,
        GetObjectPipe,
        ConsoleLogPipe,
        SafePipe,
        ApplicationCodesDescription,
        ReplaceStringPipe,
        SearchCountryPipe,
        ReplaceUnderscorePipe,
        AlphabetWithSpaceDirective,
        NumbersAndSlashDirective,
        CurrencyPipe,
    ],
    providers: [CurrencyPipe],
})
export class CoreModule {
}

